import {
    SALEORDERS_SUCCESSFUL_GET,
    SALEORDERS_UPDATE_FILTERCUSTOMER,
    SALEORDERS_UPDATE_FILTERSTATUS,
    SALEORDERS_UPDATE_FILTERSTARTDATE,
    SHOW_ERROR_MESSAGE
} from 'reducers/constants';

import HttpClient from "utils/HttpClient/HttpClient"
import { SALEORDERS_UPDATE_FILTERENDDATE } from '../constants';

export const fetchSaleOrders = (requestData, resolve, reject) => dispatch => {
    new HttpClient(true).get("oga/saleorders",
        {
            params: requestData
        })
        .then((response) => {
            dispatch({
                type: SALEORDERS_SUCCESSFUL_GET,
                payload: response.data
            });
            resolve();
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
            resolve();
        });
}

export const updateFilterCustomer = (customer) => dispatch => {
    dispatch(
        {
            type: SALEORDERS_UPDATE_FILTERCUSTOMER,
            payload: customer
        }
    )
}

export const updateFilterOrderStatus = (status) => dispatch => {
    dispatch(
        {
            type: SALEORDERS_UPDATE_FILTERSTATUS,
            payload: status
        }
    )
}

export const updateFilterStartDate = (date) => dispatch => {
    dispatch(
        {
            type: SALEORDERS_UPDATE_FILTERSTARTDATE,
            payload: date
        }
    )
}

export const updateFilterEndDate = (date) => dispatch => {
    dispatch(
        {
            type: SALEORDERS_UPDATE_FILTERENDDATE,
            payload: date
        }
    )
}









// WEBPACK FOOTER //
// ./src/reducers/saleorders/saleordersActions.js